import {
  getList,
  getItemBreadcrumbs,
  searchFiles,
  storeDirectory,
  renameDirectory,
  renameFile,
  moveItems,
  bulkDelete,
  getTags,
  setTags,
  updateAccessManage,
} from '../../repository/files/index';
import { getInflection } from '../../helpers/helpers';

const state = {
  filesList: null,
  dialogVisibility: false,
  activeListItem: null,
  postsPerPage: 100,
  totalPages: null,
  currentPage: 1,
  query: null,
  breadcrumbs: null,
  selectedFiles: [],
  tags: [],
  fileDragInProgress: false,
  fileUploadInProgress: false,
};

const getters = {
  filesList: store => store.filesList,
  dialogVisibility: store => store.dialogVisibility,
  activeListItem: store => store.activeListItem,
  postsPerPage: store => store.postsPerPage,
  query: store => store.query,
  totalPages: store => store.totalPages,
  breadcrumbs: store => store.breadcrumbs,
  selectedFiles: store => store.selectedFiles,
  currentPage: store => store.currentPage,
  tags: store => store.tags,
  fileDragInProgress: store => store.fileDragInProgress,
  fileUploadInProgress: store => store.fileUploadInProgress,
};

const mutations = {
  SET_FILES_LIST(state, filesList) {
    state.filesList = filesList;
  },
  ADD_FILES(state, filesList) {
    state.filesList.push(...filesList);
  },
  SET_TOTAL_PAGES(state, pages) {
    state.totalPages = pages;
  },
  SET_CURRENT_PAGE(state, page) {
    state.currentPage = page;
  },
  SET_DIALOG_VISIBILITY(state, type) {
    state.dialogVisibility = type;
  },
  SET_ACTIVE_LIST_ITEM(state, id) {
    state.activeListItem = id;
  },
  SET_QUERY(state, query) {
    state.query = query;
  },
  SET_BREADCRUMBS(state, breadcrumbs) {
    state.breadcrumbs = breadcrumbs;
  },
  ADD_SELECTED_FILE(state, id) {
    if (!state.selectedFiles.includes(id)) {
      state.selectedFiles.push(id);
    }
  },
  REMOVE_SELECTED_FILE(state, id) {
    const index = state.selectedFiles.findIndex(file => file.id === id);
    if (index > -1) {
      state.selectedFiles.splice(index, 1);
    }
  },
  CLEAR_SELECTED_FILES(state) {
    if (state.selectedFiles.length > 0) {
      state.selectedFiles = [];
    }
  },
  SET_TAGS(state, tags) {
    state.tags = tags;
  },
  SET_FILE_DRAG_ACTIVITY(state, inProgress) {
    state.fileDragInProgress = inProgress;
  },
  SET_FILE_UPLOAD_ACTIVITY(state, inProgress) {
    state.fileUploadInProgress = inProgress;
  },
};

const actions = {
  setQuery({ commit }, query) {
    commit('SET_CURRENT_PAGE', 1);
    commit('SET_QUERY', query);
  },
  async getBreacrumbs({ commit }, id) {
    if (id) {
      let breadcrumbs = await getItemBreadcrumbs(id);
      if (breadcrumbs.data) {
        breadcrumbs = breadcrumbs.data.data.items;
        commit('SET_BREADCRUMBS', breadcrumbs);
      }
    } else {
      commit('SET_BREADCRUMBS', null);
    }
  },
  async getFilesList({ commit, dispatch, state }, singleParams) {
    const params = {
      length: state.postsPerPage,
      page: state.currentPage,
      ...singleParams,
      ...state.query,
    };
    commit('SET_FILES_LIST', null);
    let filesList = await getList(params);
    await dispatch('getBreacrumbs', singleParams.parent_item_id);
    filesList = filesList.data.data;
    const { totalPages, items } = filesList;
    commit('SET_FILES_LIST', items);
    commit('SET_TOTAL_PAGES', totalPages);
  },
  async getFilesPage({ commit, state }, singleParams) {
    const params = {
      length: state.postsPerPage,
      page: state.currentPage,
      ...singleParams,
      ...state.query,
    };
    const filesPage = await getList(params);
    const { items } = filesPage.data.data;
    commit('ADD_FILES', items);
  },
  async getSearchList({ commit, dispatch, state }, singleParams) {
    const params = {
      length: state.postsPerPage,
      page: state.currentPage,
      ...singleParams,
      ...state.query,
    };
    commit('SET_FILES_LIST', null);
    let filesList = await searchFiles(params);
    await dispatch('getBreacrumbs', singleParams.parent_item_id);
    filesList = filesList.data.data;
    const { totalPages, items } = filesList;
    commit('SET_FILES_LIST', items);
    commit('SET_TOTAL_PAGES', totalPages);
  },
  async getSearchPage({ commit, state }, singleParams) {
    const params = {
      length: state.postsPerPage,
      page: state.currentPage,
      ...singleParams,
      ...state.query,
    };
    const filesPage = await searchFiles(params);
    const { items } = filesPage.data.data;
    commit('ADD_FILES', items);
  },
  async getFilesByRoute({ dispatch, commit }, data) {
    commit('SET_CURRENT_PAGE', 1);
    if (data.route === 'searchFiles') {
      await dispatch('getSearchList', data.viewParams);
    } else {
      await dispatch('getFilesList', data.viewParams);
    }
  },
  async storeDir({ dispatch }, dirData) {
    const currentDialogData = state.dialogVisibility;
    await storeDirectory(dirData);
    const fileViewData = {
      viewParams: currentDialogData.data,
      route: currentDialogData.view,
    };
    dispatch('setDialogVisbility', false);
    await dispatch('getFilesByRoute', fileViewData);
  },
  async renameItem({ state, dispatch }, data) {
    const currentDialogData = state.dialogVisibility;
    if (currentDialogData.fileType === 1) {
      await renameDirectory(currentDialogData.id, data);
    } else {
      await renameFile(currentDialogData.id, data);
    }
    const fileViewData = {
      viewParams: currentDialogData.viewParams,
      route: currentDialogData.view,
    };
    dispatch('setDialogVisbility', false);
    await dispatch('getFilesByRoute', fileViewData);
  },
  async deleteItems({ state, dispatch }, data) {
    const currentDialogData = state.dialogVisibility;
    await bulkDelete(data);
    const movedFiles = data.items_id.length;
    const inflection = getInflection(movedFiles, 'element', 'elementy', 'elementów');
    const snackBarText = `Usunięto ${movedFiles} ${inflection}.`;
    dispatch('showSnackbar', snackBarText);
    const fileViewData = {
      viewParams: currentDialogData.viewParams,
      route: currentDialogData.view,
    };
    dispatch('setDialogVisbility', false);
    await dispatch('getFilesByRoute', fileViewData);
    dispatch('clearSelectedFiles');
  },
  async moveFiles({ state, dispatch }, data) {
    const currentDialogData = state.dialogVisibility;
    await moveItems(data);
    const viewParams = {
      client_id: currentDialogData.client_id,
      parent_item_id: currentDialogData.parent_item_id,
    };
    const movedFiles = data.items_id.length;
    const inflection = getInflection(movedFiles, 'element', 'elementy', 'elementów');
    const snackBarText = `Przeniesiono ${movedFiles} ${inflection}.`;
    dispatch('showSnackbar', snackBarText);
    const fileViewData = {
      viewParams,
      route: currentDialogData.view,
    };
    dispatch('setDialogVisbility', false);
    await dispatch('getFilesByRoute', fileViewData);
    dispatch('clearSelectedFiles');
  },
  async getTagsList({ commit }) {
    let tags = await getTags();
    if (tags.data && tags.data.data) {
      tags = tags.data.data;
      tags = tags.items || [];
      commit('SET_TAGS', tags);
    }
  },
  async saveTags({ dispatch }, tags) {
    const currentDialogData = state.dialogVisibility;
    await setTags(currentDialogData.fileId, tags);
    const fileViewData = {
      viewParams: currentDialogData.viewParams,
      route: currentDialogData.view,
    };
    dispatch('setDialogVisbility', false);
    await dispatch('getFilesByRoute', fileViewData);
    dispatch('clearSelectedFiles');
  },
  async saveAccesses({ state, dispatch }, data) {
    const currentDialogData = state.dialogVisibility;
    await updateAccessManage(data);
    const fileViewData = {
      viewParams: currentDialogData.viewParams,
      route: currentDialogData.view,
    };
    dispatch('setDialogVisbility', false);
    await dispatch('getFilesByRoute', fileViewData);
  },
  setCurrentPage({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  setSelectedItem({ commit }, id) {
    commit('ADD_SELECTED_FILE', id);
  },
  removeSelectedItem({ commit }, id) {
    commit('REMOVE_SELECTED_FILE', id);
  },
  clearSelectedFiles({ commit }) {
    commit('CLEAR_SELECTED_FILES');
  },
  setDialogVisbility({ commit }, type) {
    commit('SET_DIALOG_VISIBILITY', type);
  },
  showSnackbar({ dispatch }, text) {
    dispatch('app/setSnackBar', text, { root: true });
  },
  setFileDragActivity({ commit }, inProgress) {
    commit('SET_FILE_DRAG_ACTIVITY', inProgress);
  },
  setFileUploadActivity({ commit }, inProgress) {
    commit('SET_FILE_UPLOAD_ACTIVITY', inProgress);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
